// This file is used to map the fields for the NGL North Carolina Enrollment Form
import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'
import { usePaymentSetup } from '@/components/documents/Foxit/FormMapping/composables/PaymentFields'

export default class NGLNCEnrollmentForm {
	private fieldNameProvider = getNGLFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider, as well as functions to get the value for the field via the fieldsValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		// Insured
		'insuredFirstName',
		'insuredMiddleInitial',
		'insuredLastName',
		'insuredMaleCheck',
		'insuredFemaleCheck',
		'insuredDateOfBirth',
		'insuredAge',
		'insuredEmail',
		'insuredPrimaryPhone',
		'insuredSSN',

		// Policy Owner
		'policyOwnerFields',

		// Purchaser Contact (Mailing Address)
		'purchaserEmail',
		'purchaserPhone',
		'purchaserSecondaryPhone',
		'purchaserZip',
		'purchaserState',
		'purchaserCity',
		'purchaserCityState',

		// Beneficiary
		'beneficiaryName',
		'beneficiaryRelationship',

		// Funeral Home
		'funeralHomeName',
		'purchaserAddress',
		'funeralHomePhone',
		'funeralHomeZip',
		'funeralHomeCity',
		'funeralHomeState',
		'funeralHomeStreet',
		'funeralHomeRepresentativePrintedName',
		'funeralHomeRepresentativeProducerNumber',

		// Payment Term
		'paymentTermChecks',

		// Payment Mode
		'paymentModeFields',

		// Payment Amount
		'paymentAmountFields',
	]

	private unfilledFields = [
		'contractNumber',
		'applicantReplacement1YesCheck',
		'applicantReplacement1NoCheck',
		'applicantReplacement2YesCheck',
		'applicantReplacement2NoCheck',
		'appointmentCode',
	]

	constructor(planHolderId: string) {
		const { setFieldNameProvider } = useFormFillHelper()
		const { identitySetup } = useIdentitySetup()
		const { paymentSetup } = usePaymentSetup()

		identitySetup(planHolderId, ['planHolder', 'funeralHome', 'salesContact'])
		paymentSetup(planHolderId, ['paymentDetails'])
		setFieldNameProvider(this.fieldNameProvider)
	}

	getFormMappings() {
		const { formatFields, mapFields } = useFormFillHelper()
		const values = mapFields(this.fields)

		return formatFields(values)
	}
}
